import React, { memo } from 'react';
import { compare } from '../../../prat_screen/gt/validation/sort';
import CSVReader from "react-csv-reader";
import './InnovationForm.styles.scss';

const InnovationFormTable = memo((
    {
        year,
        data,
        handleVolumeValue,
        isDisabled,
        handleFileUpload,
        csvFileReset,
        handleDownloadPromotionCSV
    }
) => {

    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    return (
        <div className='innovation-table-m-form-container'>
            <div className='innovation-table-heading'>
                Innovation Volume {year}
                <div style={{ display: 'flex' }}>
                    <img style={{marginRight: '8px'}} src={require('../../../assets/images/CSV_download_icon.svg')} alt='' onClick={handleDownloadPromotionCSV}/>
                    <div className='upload-image-container'>
                        <img src={require('../../../assets/images/CSV_upload_icon.svg')} alt='' />
                        <div key={csvFileReset || ''}>
                            <CSVReader cssInputClass="input-upload" accept='.csv' onFileLoaded={(data, fileInfo) => handleFileUpload(data, fileInfo)} parserOptions={papaparseOptions} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='innovation-form-table'>
                <table className='in-table'>
                    <thead>
                        <tr>
                            <th className='in-tb-cell in-table-header' style={{ textAlign: 'left', minWidth: '96px' }} >WEEK</th>
                            <th className='in-tb-cell in-table-header'>VOLUME</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data
                                .sort(compare)
                                .map(item => (
                                    <tr key={item.WeekNo} >
                                        <td className='in-tb-cell' style={{ textAlign: 'left', paddingLeft: '16px' }} >{item.WeekNo}</td>
                                        <td className='in-tb-cell'><input type='number' disabled={isDisabled} className='in-cell-input' value={parseFloat(item.Volume)} onChange={(e) => handleVolumeValue(e, item)} /></td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
});

export default InnovationFormTable;